<template>
  <div>
    <el-row>
      <el-col v-for="article in articleList" :key="article.ID" :span="8">
        <div @click="goToArticle(article.ID)">
          <el-card class="custom-card">
            <div class="card-title">{{ article.title }}</div>
            <!-- <div class="summary">{{ article.summary }}</div> -->
            <!-- <div>Author: {{ article.author }}</div> -->
            <!-- <div>Published: {{ article.publishDate }}</div> -->
            <div>
              <el-tag v-for="tag in article.tags" :key="tag">{{ tag }}</el-tag>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  export default {
    props: ['id'],
    data() {
      return {
        articles: [],
        articleList: [],
        queryParam: {
          title: "",
          pageSize: 100,
          pageNum: 1,
          total: 0,
        },
      };
    },
    created() {

      // 在这里调用后端接口获取文章列表数据，并将数据赋值给 articles
      // 假设后端返回的数据格式为 [{ id, title, summary, author, publishDate, tags }, ...]
      // this.fetchArticles();
      this.getArticleList();

    },
    methods: {
      async getArticleList() {
        const { data: res } = await this.$http.post("getArticleList", {
          title: this.queryParam.title,
          pagesize: this.queryParam.pageSize,
          pagenum: this.queryParam.pageNum
        })
        if (res.status != 200) return this.$message.error(res.message);
        this.articleList = res.data
        this.queryParam.total = res.total
      },
      fetchArticles() {
        // 在这里调用后端接口获取文章列表数据，并将数据赋值给 articles
        // 假设后端返回的数据格式为 [{ id, title, summary, author, publishDate, tags }, ...]
        // 示例数据
        this.articles = [
          {
            id: 1,
            title: 'Sample Article 1',
            summary: 'This is a sample article.',
            author: 'John Doe',
            publishDate: '2023-07-26',
            tags: ['Technology', 'Web Development'],
          },
          {
            id: 2,
            title: 'Sample Article 2',
            summary: 'Another sample article.',
            author: 'Jane Smith',
            publishDate: '2023-07-25',
            tags: ['Science', 'AI'],
          },
          {
            id: 3,
            title: 'Sample Article 2',
            summary: 'Another sample article.',
            author: 'Jane Smith',
            publishDate: '2023-07-25',
            tags: ['Science', 'AI'],
          },
          {
            id: 4,
            title: 'Sample Article 2',
            summary: 'Another sample article.',
            author: 'Jane Smith',
            publishDate: '2023-07-25',
            tags: ['Science', 'AI'],
          },
        ];
      },
      goToArticle(id) {
        this.$router.push({ path: `/ArticleDetail/${id}` })
        // 在这里根据文章的 id 跳转到文章详情页
        // 你可以使用路由来实现页面跳转，具体实现方式根据你的前端框架而定
        console.log('Navigating to article with ID:', id);
        // 例如，使用 Vue Router
        // this.$router.push(`/articles/${id}`);
      },
    },
  };
</script>

<style scoped>
  .el-card {
    margin: 10px;
    /* 外边距，可根据需要调整间隔大小 */
  }

  .card-title {
    font-weight: bold;
  }

  .summary {
    color: gray;
    font-size: small;
  }
  
  .custom-card {
    background-color: #f0f0f0; /* Set your desired background color */
    border-radius: 8px; /* Add rounded corners to the card */
    padding: 5px; /* Add some padding to the card content */
    box-shadow: 0 4px 8px rgba(212, 6, 9, 0.1); /* Add a subtle shadow to the card */
  }
</style>